package app.alefly.analytics

import app.alefly.domain.model.ChallengeId
import app.alefly.domain.model.Difficulty
import app.alefly.domain.model.Platform
import app.alefly.domain.model.QuizId
import app.alefly.domain.model.TenantId
import kotlinx.serialization.Serializable

@Serializable
enum class AnalyticsEventName {
    TENANT_VIEW,
    CHALLENGE_VIEW,
    QUIZ_START,
    QUIZ_ANSWER,
    QUIZ_COMPLETE,
    RANKING_SUBMIT,
    SHARE_OPEN,
    SHARE_SUCCESS,
    INVITE_LANDING,
    INVITE_ACCEPTED,
    HINT_USED,
    INSTALL_CTA_CLICK,
    QUIZ_ABANDON,
    RANKING_VIEW,
    NOTIFICATION_TAPPED,
    PAGE_VIEW,
    AUTH_SIGN_IN,
    DISPLAY_NAME_CHANGED,
    QUESTION_VIEW,
    AD_IMPRESSION,
    AD_BANNER_IMPRESSION,
    SEO_TO_LOBBY,
    HINT_REQUESTED,
    REWARDED_AD_COMPLETED,
    RELATED_TENANTS_IMPRESSION,
    RELATED_TENANT_CLICK,
    GLOBAL_CHALLENGE_ACTION,
}

@Serializable
enum class GlobalChallengeAction(val wireValue: String) {
    VIEWED("viewed"),
    CARD_IMPRESSION("card_impression"),
    CARD_ENTER_TAP("card_enter_tap"),
    JOINED("joined"),
    STARTED("started"),
    COMPLETED("completed"),
    PUSH_PROCESSED("push_processed"),
    PUSH_DECISION("push_decision"),
    PUSH_NOTIFICATION_REQUESTED("push_notification_requested"),
    PUSH_NOTIFICATION_OPENED("push_notification_opened"),
    RANKING_VIEWED("ranking_viewed"),
    SHARED("shared"),
    NOTIFICATION_OPT_IN("notification_opt_in"),
}

@Serializable
data class AnalyticsContext(
    val tenantId: TenantId? = null,
    val platform: Platform,
    val locale: String,
    val quizId: QuizId? = null,
    val challengeId: ChallengeId? = null,
    val difficulty: Difficulty? = null,
    val clientId: String? = null,
)

@Serializable
data class AnalyticsEvent(
    val name: AnalyticsEventName,
    val context: AnalyticsContext,
    val attributes: Map<String, String> = emptyMap(),
)
